export const useIsMac = () => {
  return navigator.userAgent.includes("Mac");
};
